var render = function render(){var _vm=this,_c=_vm._self._c;return _c('option',{domProps:{"value":_vm.option.data.properties.nid,"selected":_vm.option.value === _vm.value ? true : false,"innerHTML":_vm._s(_vm.option.data.properties.title)}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }